module.exports = __webpack_public_path__ + "static/media/alum_gor_slid.a4f2b63d.png";